export var DepositStatusType;
(function (DepositStatusType) {
    DepositStatusType[DepositStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    DepositStatusType[DepositStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    DepositStatusType[DepositStatusType["FAIL"] = 3] = "FAIL";
    DepositStatusType[DepositStatusType["EXPIRED"] = 4] = "EXPIRED";
    DepositStatusType[DepositStatusType["CANCEL"] = 5] = "CANCEL";
})(DepositStatusType || (DepositStatusType = {}));
//# sourceMappingURL=DepositStatusType.js.map